import React from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

const linkStyle = {
  color: 'var(--o, #ff6a1a)',
  textDecoration: 'underline',
  fontWeight: 600,
  fontFamily: "'Share Tech Mono', monospace",
  fontSize: 12,
  letterSpacing: '0.04em',
};

export const txToast = (description, txLink, selectedTab) => {
  const openLinks = () => {
    if (typeof txLink === 'string') {
      window.open(txLink, '_blank');
    } else if (Array.isArray(txLink)) {
      txLink.forEach((link) => {
        window.open(link, '_blank');
      });
    }
  };
  return toast.info(
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, minWidth: 220 }}>
      <div style={{ color: 'var(--text, #ece8e0)', lineHeight: '1.2' }}>{description}</div>
      {selectedTab && (
        <Link to="/my-nft" style={linkStyle} state={{ selectedTab: selectedTab }}>
          View in My Wallet
        </Link>
      )}
      <Link to="/dashboard" style={linkStyle}>
        Track the transaction
      </Link>

      <button
        type="button"
        onClick={() => openLinks(txLink)}
        style={{
          ...linkStyle,
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          textAlign: 'left',
        }}
      >
        View on Explorer
      </button>
    </div>,
  );
};
